import * as React from 'react'

export const CoworkersIcon = React.forwardRef<
  SVGSVGElement,
  {
    color?: string
    width?: number
    height?: number
  } & React.SVGProps<SVGElement>
>(({ style, ...props }, ref) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      height="17"
      viewBox="0 0 16 17"
      width="16"
      style={style}
      {...props}
      ref={ref}
    >
      <path
        d="M11.3337 14.5V13.1667C11.3337 12.4594 11.0527 11.7811 10.5526 11.281C10.0525 10.781 9.37424 10.5 8.66699 10.5H3.33366C2.62641 10.5 1.94814 10.781 1.44804 11.281C0.947944 11.7811 0.666992 12.4594 0.666992 13.1667V14.5"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.2"
      />
      <path
        d="M5.99967 7.83333C7.47243 7.83333 8.66634 6.63943 8.66634 5.16667C8.66634 3.69391 7.47243 2.5 5.99967 2.5C4.52692 2.5 3.33301 3.69391 3.33301 5.16667C3.33301 6.63943 4.52692 7.83333 5.99967 7.83333Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.2"
      />
      <path
        d="M15.333 14.4998V13.1664C15.3326 12.5756 15.1359 12.0016 14.7739 11.5346C14.4119 11.0677 13.9051 10.7341 13.333 10.5864"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.2"
      />
      <path
        d="M10.667 2.58643C11.2406 2.73329 11.749 3.06689 12.1121 3.53463C12.4752 4.00237 12.6722 4.57765 12.6722 5.16976C12.6722 5.76187 12.4752 6.33715 12.1121 6.80488C11.749 7.27262 11.2406 7.60622 10.667 7.75309"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.2"
      />
    </svg>
  )
})
